import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable()
export class AppLanguageInterceptor implements HttpInterceptor {
  public constructor(private translate: TranslateService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.adminUrl)) return next.handle(request);

    return next.handle(
      request.clone({
        setHeaders: {
          'X-App-Language': this.translate.currentLang,
        },
      }),
    );
  }
}
